import React from 'react';

export default class CodeMirror extends React.Component 
{
    constructor(props)
    {
        super(props);
    }

    static defaultProps = 
    {
        name: "summernote",
        value: "",
        onChange: function(e){}
    };

    shouldComponentUpdate()
    {
        return false;
    }

    componentDidMount()
    {
        let self = this; let CodeMirror = window.CodeMirror;

        let editor = CodeMirror.fromTextArea(document.getElementById("code"), {lineNumbers: true, matchBrackets: true, styleActiveLine: true}); editor.setSize(null, 407);
    
        editor.on('change',function(cMirror)
        {
            let value = cMirror.getValue();

            self.props.onChange({ target: { name: self.props.name, value: value }});
        });
    }

    render() 
    {
        return (
            <textarea id="code" style={{width: "100%", height: "407px", border: "solid 1px #bbbbbb"}}>{this.props.value}</textarea>
        )
    }
}
